export const HEADING = "Next, let's choose a waiting period";
export const SUB_HEADING =
  "This is the period of time you have to wait from the start of your disability to when benefits start. Here's how it works:";

export const AFTER_IMAGE_TEXT =
  'Policies have waiting periods of 90, 180 or 365 days (sometimes 30 days).';

export const LIST_TEXT_ITEMS = [
  'The longer the period, the less expensive the policy',
  'Policies typically pay at the end of the month, so if you have a 90-day waiting period, you won’t receive the first payment until day 120.',
];
export const WAITING_PERIOD_DIAGRAM_URL =
  'https://policygenius.com/assets/disability/waiting-period.svg';
export const WAITING_PERIOD_DIAGRAM_ALT =
  'The waiting period is the time between the start of your disability and the start of your benefit period;';

export const RECOMMENDATION_HEADING = 'Our Recommendation';
export const RECOMMENDATION_TEXT_1 =
  'The most cost-effective (and commonly selected) waiting period is 90 days.';
export const RECOMMENDATION_TEXT_2 =
  'Any shorter and price really increases. You can select a longer waiting period if you are comfortable covering with your savings.';
